import React from 'react';

import { WorkFeedActionNeeded } from '../components/WorkFeedActionNeeded/WorkFeedActionNeeded';
import { EngagementsTabNavigation } from '../components/EngagementsTabNavigation/EngagementsTabNavigation';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type WorkFeedActionNeededPageProps = {
  name?: string;
};

export const WorkFeedActionNeededPage = ({
  name = 'WORK_FEED_ACTION_NEEDED_PAGE',
}: WorkFeedActionNeededPageProps) => {
  useDocumentTitle('Work Feed - Actions Needed');
  return (
    <div data-test={name}>
      <EngagementsTabNavigation
        startTab="OPPORTUNITY_FEED_TAB"
        pathToEngagements="../.."
      />
      <WorkFeedActionNeeded />
    </div>
  );
};
